export default __webpack_public_path__ + "static/media/Thought Gear Oxide Overflow.06de72cf.png";